module.exports = __webpack_public_path__ + "img/facebook.4ad9e124.svg";